import {useNavigate} from "react-router-dom";

export default function useGoToNavigation() {
    const navigate = useNavigate();

    const goToNavigation = (url: string | -1 | number, state: {}, isTrue: boolean) => {
        if (typeof url === "number") {
            navigate(url)
        } else {
            navigate(process.env.PUBLIC_URL + "/" + url, {
                state,
                replace: isTrue,
            });
        }
    };

    return {goToNavigation};
}